/* ==========================================================================
   SearcherFerry > Client
   ========================================================================== */

/* Import modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const { initCalendar } = require('./calendar');
const { initSelect, storeCachedPorts } = require('./select');
const { initButton } = require('./button');
const { initAccommodation } = require('./accommodation');
const { initLoading } = require('./loading');
const { initVehiclePet } = require('./panel');
const transactions = require('./transactions');
const config = require('./config');

/**
 * SearcherFerry component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function SearcherFerryHotel(selector = '[data-component="SearcherFerryHotel"]', customConfig = {}) {
    if (elementExist(selector)) {
        // Instance reference
        const instance = {};

        // Element reference
        instance.element = document.querySelector(selector);

        instance.selector = selector;

        /* Language context */
        instance.language = instance.element.getAttribute('data-language');

        // Element loadingData
        instance.loadingData = JSON.parse(instance.element.dataset.loading);

        /* Config reference */
        instance.config = {
            ...config(),
            ...customConfig,
            ...(function Fn() {
                const result = JSON.parse(instance.element.dataset.config);
                instance.element.dataset.config = '';
                return result;
            })()
        };

        initComponents(instance);

        return instance;
    }
};

function initComponents(instance) {
    const ref = instance;
    const { selector } = instance;

    // Select
    ref.location = initSelect(selector, instance, {
        ...config().location
    });

    transactions.getPorts(instance, storeCachedPorts);
    // Calendar
    initCalendar(`${selector} [data-component="Calendar"][data-type="${config().type.calendar}"]`, instance, {
        ...config().calendar
    });

    // Passenger accommodation panel
    ref.passenger = initAccommodation(instance);

    // pet panel
    const uiPanelPetEl = instance.element.querySelector(
        `${selector} [data-component="UiPanel"][data-type="${config().type.uipanel.vehicle.panel}"]`
    );
    const uIpanelId = uiPanelPetEl.dataset.id;
    uiPanelPetEl.dataset.type += `-${uIpanelId}`;
    const uIPanelType = uiPanelPetEl.dataset.type;

    ref.vehicle = initVehiclePet(`${selector} [data-component="UiPanel"][data-type="${uIPanelType}"]`, instance, {
        ...instance.config.vehicle,
        type: uIPanelType
    });

    /* Loading */
    ref.loading = initLoading(selector, { ...instance.config.loading }, instance);

    // Submit button
    ref.submit = initButton(`${selector} [data-component="Button"][data-type="${config().type.submit}"]`, instance, {
        ...config().submit
    });
}
